<template>
  <div class="column full-height full-width">
    <div class="col">
      <q-splitter
        horizontal
        v-model="splitterModel"
        style="height: 100%"
        ref="attendance"
        :limits="[0, 100]"
      >
        <template #before>
          <slot name="before" />
        </template>

        <template #separator>
          <DragHorizontalIcon v-if="hasProfiler" />
        </template>

        <template #after>
          <slot
            name="after"
            v-if="hasProfiler"
          />
        </template>
      </q-splitter>
    </div>
  </div>
</template>

<script>
import DragHorizontalIcon from '@/assets/icons/DragHorizontalIcon.svg'

export default {
  components: {
    DragHorizontalIcon
  },

  props: {
    hasProfiler: {},
    isEmail: {}
  },

  data () {
    return {
      splitterModel: this.hasProfiler ? 50 : 100
    }
  },

  watch: {
    hasProfiler (val) {
      this.splitterModel = val ? 50 : 100
    },
    splitterModel: {
      deep: true,
      handler (newValue, oldValue) {
        const nv = newValue ? newValue.toFixed(1) : '0'
        const ov = oldValue ? oldValue.toFixed(1) : '0'
        if (nv === ov) return

        const areas = this.$refs?.attendance?.$children
        if (!areas?.length) return
        if (areas[0]?.recalcArea) areas[0].recalcArea()
      }
    }
  }
}
</script>
